module.exports = __webpack_public_path__ + "img/fineboy.8b15dbf9.png";